
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/manuals/[...slug]",
      function () {
        return require("private-next-pages/manuals/[...slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/manuals/[...slug]"])
      });
    }
  